import React from 'react';
import { Icon } from '@sizeid/commons/components/SvgImage/index';
import { WrappedFieldProps } from 'redux-form';

import Tooltip from 'components/Tooltip';

import Input, { Textarea } from './styled/Input';
import InputContainer from './styled/InputContainer';
import { FIELD_ICONS } from './constants';

const resolveIcon = (
  name: string,
  type?: string,
): string | null | undefined => {
  let icon: string | null | undefined = null;
  const iconByFieldName = FIELD_ICONS[name as keyof typeof FIELD_ICONS];
  const iconByFieldType = type
    ? FIELD_ICONS[type as keyof typeof FIELD_ICONS]
    : null;

  if (iconByFieldName) {
    icon = iconByFieldName;
  } else if (iconByFieldType) {
    icon = iconByFieldType;
  }

  return icon;
};

const FormField: React.FC<
  WrappedFieldProps & { type?: string; noIcon: boolean }
> = props => {
  const { input, meta, type, noIcon, ...rest } = props;
  const icon = props.noIcon ? null : resolveIcon(input.name, type);

  return (
    <InputContainer noIcon={noIcon}>
      {icon && <Icon image={icon} color="light" />}
      {type === 'textarea' ? (
        <Textarea {...input} {...rest} />
      ) : (
        <Input {...input} {...rest} type={type || 'text'} />
      )}
      {meta.touched && meta.error && (
        <Tooltip message={meta.error} direction="left" danger>
          <Icon image="disabled" red />
        </Tooltip>
      )}
    </InputContainer>
  );
};

export { default as FormFieldGroup } from './styled/FormFieldGroup';
export { default as FormFieldLabel } from './styled/FormFieldLabel';
export { default as FormFieldSet } from './styled/FormFieldSet';
export { default as FormFieldSetHorizontal } from './styled/FormFieldSetHorizontal';

export default FormField;
